const TRON_BASE58 = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

/**
 * Client-side TRON address checks (format only). Server performs full Base58Check validation.
 */
export function validateTronAddressFormat(address: string): string | null {
  const trimmed = address.trim();

  if (!trimmed) {
    return 'Address is required';
  }

  if (/\s/.test(trimmed)) {
    return 'Address must not contain whitespace';
  }

  if (trimmed.startsWith('0x') || trimmed.startsWith('0X')) {
    return 'Use the Base58 address starting with T, not hex';
  }

  if (!trimmed.startsWith('T')) {
    return 'TRON address must start with T';
  }

  if (trimmed.length !== 34) {
    return 'TRON address must be exactly 34 characters';
  }

  if (!TRON_BASE58.test(trimmed)) {
    return 'Address contains invalid characters for TRON Base58';
  }

  return null;
}
